import { UserPermissions } from '@agroone/entities'
import { inject, Injectable } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { map, Observable } from 'rxjs'
import { UserService } from '../../features/user-preferences/user.service'
import { NAV_ITEMS, NavItem } from '../navigation/navigation.config'

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly userService = inject(UserService)

  readonly permissions$ = this.userService.getUser().pipe(map((user) => user.permissions ?? []))
  readonly permissions = toSignal(this.permissions$, { initialValue: [] as UserPermissions[] })

  hasAnyPermission(requiredPermissions?: UserPermissions[]): boolean {
    if (!requiredPermissions?.length) return true

    const currentPermissions = this.permissions()
    return requiredPermissions.some((permission) => currentPermissions.includes(permission))
  }

  hasAnyPermission$(requiredPermissions?: UserPermissions[]): Observable<boolean> {
    return this.permissions$.pipe(
      map((currentPermissions) => {
        if (!requiredPermissions?.length) return true
        return requiredPermissions.some((permission) => currentPermissions.includes(permission))
      }),
    )
  }

  getFirstAllowedRoute(navItems: NavItem[] = NAV_ITEMS): string | null {
    const firstAllowedItem = navItems.find((item) => this.hasAnyPermission(item.permissions))
    return firstAllowedItem?.route ?? null
  }

  getFirstAllowedRoute$(navItems: NavItem[] = NAV_ITEMS): Observable<string | null> {
    return this.permissions$.pipe(
      map((currentPermissions) => {
        const firstAllowedItem = navItems.find((item) => {
          if (!item.permissions?.length) return true
          return item.permissions.some((permission) => currentPermissions.includes(permission))
        })

        return firstAllowedItem?.route ?? null
      }),
    )
  }
}
